<template>
  <div class="hot-class">
    <studyTable :tableData="tableDataTemp" :pages="pages" :columns="columns" :num="num"></studyTable>
  </div>
</template>
<script>
import studyTable from "./module/_studyTable";
export default {
  data() {
    return {
      tableData: [
        // { className: "【本土课件】我在您身边", number: 79 },
        // {
        //   className: "【本土课件】电商助力脱贫致富—东坡区优秀第一书记彭勇",
        //   number: 61
        // }
      ],
      columns: [
        { name: "课件名称", prop: "title" },
        { name: "学习条数", prop: "count" }
      ],
      tableDataTemp: [],
      pages: 1,
      num:0,
    };
  },
  components: {
    studyTable
  },
  methods: {
    getMsg() {
      this.tableDataTemp = [];
      this.axios
        .post("/api/Statistics/Data", {
          c2town: sessionStorage.getItem("town"),
          c1roleid: sessionStorage.getItem("roleid"),
          c2name: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log(e.data);
          switch (e.data.code) {
            case 0:
              this.tableData = e.data.msg;
              this.num = this.tableData.length
              this.tableData.some((item, index) => {
                if (index == 10) return true;
                else {
                  this.tableDataTemp.push(item);
                }
              });
              this.pages = Number.parseInt(
                this.tableData.length % 10 > 0
                  ? this.tableData.length / 10 + 1
                  : this.tableData.length
              );
              console.log(this.pages);
              break;
            default:
              break;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted(){
    this.getMsg()
  }

};
</script>
<style lang='scss' scoped>
.hot-class {
  padding-top: 1rem;
  font-size: 0.3rem;
  min-height: 100vh;
  background: #fff;
}
</style>